const Middle: React.FC<React.PropsWithChildren> = ({ children }) => (
  <div className="border-t-6 border-blue bg-blue100 py-11">
    <div className="items-between mx-auto flex max-w-[1070px] flex-wrap gap-y-5 lg:gap-x-20">
      {children}
    </div>
  </div>
);

export default Middle;
